module.exports = __webpack_public_path__ + "static/media/stillColdDrip.355d51cb.png";